import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createAgendaService, type CreateAgendaPayload } from '@/services/agendas'
import { AGENDAS_QUERY_KEY } from '@/hooks/agendas/useAgendas'

export const useCreateAgenda = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateAgendaPayload) => createAgendaService(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENDAS_QUERY_KEY })
    },
  })
}
